import Background from '../modules/background.js';
import Loader from '../modules/loader.js';
import ModelDropdown from '../modules/model-dropdown.js';
import DealerSearch from '../modules/dealer-search.js';
import DealerResults from '../modules/dealer-results.js';
import SelectedPreferredDealer from '../modules/selected-preferred-dealer.js';

export default class SearchView {
    constructor(parent, router) {
        this.router = router;
        this.myAccount2 = window.HONDA.MyAccount2;
        this.el = parent.el.querySelector('.batd-search');
        this.header = this.el.querySelector('.batd-header');
        this.filters = this.el.querySelector('.batd-filters');
        this.background = new Background(this, router);
        this.preferredDealer = new SelectedPreferredDealer(this, router);
        this.loader = new Loader(this, router);
        this.dropdown = new ModelDropdown(this, router, true);
        this.results = new DealerResults(this, router);
        this.search = new DealerSearch(this, router);
    }

    show() {
        this.el.classList.remove('hide');
        this.dropdown.show();
        this.search.show();
        this.animate();
    }

    hide() {
        this.el.classList.add('hide');
    }

    animate() {
        const self = this;

        this.header.classList.remove('pre-animation');
        this.filters.classList.remove('pre-animation');
        this.header.classList.add('apply-animation');
        this.filters.classList.add('apply-animation');

        setTimeout(() => {
            self.background.el.classList.remove('pre-animation');
        }, 1000);
    }
}
